import { Alert, Grid, List, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

const BoostFiltersDescription = () => {
  return (
    <Alert variant="light" color="blue" title="Filters description" icon={<IconInfoCircle size={16} />} mb="md">
      <Grid>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <List size="sm" spacing="xs">
            <List.Item>
              <Text span fw={600}>Boost</Text> - Show more products that fit the criteria. Weight can be adjusted.
            </List.Item>
            <List.Item>
              <Text span fw={600}>Bury</Text> - Show fewer products that fit the criteria. Weight can be adjusted.
            </List.Item>
          </List>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <List size="sm" spacing="xs">
            <List.Item>
              <Text span fw={600}>Include</Text> - Show only products from this filter.
            </List.Item>
            <List.Item>
              <Text span fw={600}>Exclude</Text> - Don't show products from this filter.
            </List.Item>
          </List>
        </Grid.Col>
      </Grid>
    </Alert>
  );
};

export default BoostFiltersDescription;
